import { PropsWithChildren, useCallback } from "react";
import { useSelector } from "react-redux";
import { ConditionField } from "../../../../shared/reporting/api/biClient.types.ts";
import { BiCommonDataContextProvider } from "../../../../shared/reporting/contexts/BiCommonDataContextProvider.tsx";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch.ts";
import { selectConditions } from "../../../store/selectors/fieldsStateSelectors.ts";
import { selectCurrentDataSetId } from "../../../store/selectors/metaDataSelectors.ts";
import { fieldsStateActions } from "../../../store/thunks/fieldStatesThunks.ts";
import { createCurrentReportAction } from "../../../store/utils/storeUtils.ts";
import useDimensionAndMeasuresSelection from "./hooks/useDimensionAndMeasuresSelection.ts";
import useSelectCommonData from "./hooks/useSelectCommonData.ts";

const EditCommonDataProvider = ({ children }: PropsWithChildren) => {
  const { dimensionNames, measureNames } = useDimensionAndMeasuresSelection();
  const commonData = useSelectCommonData();
  const conditions = useSelector(selectConditions);
  const dataSetId = useSelector(selectCurrentDataSetId);
  const dispatch = useAppDispatch();
  const onConditionUpdate = useCallback(
    (field: ConditionField, changes: Partial<ConditionField>) => {
      dispatch(fieldsStateActions.updateCondition({ field, changes }));
    },
    [dispatch]
  );
  const onRefreshGrid = useCallback(() => {
    dispatch(createCurrentReportAction("refresh"));
  }, [dispatch]);

  return (
    <BiCommonDataContextProvider
      onRefreshGrid={onRefreshGrid}
      {...commonData}
      editMode={true}
      conditions={conditions}
      onConditionUpdate={onConditionUpdate}
      dimensionNames={dimensionNames}
      measureNames={measureNames}
      dataSetId={dataSetId ?? ""}
    >
      {children}
    </BiCommonDataContextProvider>
  );
};

export default EditCommonDataProvider;
